import { render, staticRenderFns } from "./ActionsPanelView.vue?vue&type=template&id=6a490818&scoped=true&lang=pug"
import script from "./ActionsPanelView.vue?vue&type=script&lang=ts"
export * from "./ActionsPanelView.vue?vue&type=script&lang=ts"
import style0 from "./ActionsPanelView.vue?vue&type=style&index=0&id=6a490818&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a490818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a490818')) {
      api.createRecord('6a490818', component.options)
    } else {
      api.reload('6a490818', component.options)
    }
    module.hot.accept("./ActionsPanelView.vue?vue&type=template&id=6a490818&scoped=true&lang=pug", function () {
      api.rerender('6a490818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/actions/ActionsPanel/ActionsPanelView.vue"
export default component.exports